export default __webpack_public_path__ + "static/media/biofit-builder-series-AM.e09fcb3b.png";